(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name bidding.controller:BiddingAssignCtrl
     *
     * @description
     *
     */
    angular
        .module('bidding')
        .controller('BiddingAssignCtrl', BiddingAssignCtrl);
    
    function BiddingAssignCtrl($uibModalInstance, modalParams) {
        var vm = this;
        vm.model = {
            responseCollection: modalParams.biddingCrewResponseCollection
        };

        vm.onCloseClick = function () {
            $uibModalInstance.close();
        };
        
        vm.assignTraining = function (training, assignFlag) {
            RenewalsService.assignTraining(training, vm.model.selectedCrew, assignFlag);
        };
    }
}());